import { defineComponent as r, openBlock as n, createBlock as a, unref as m, mergeProps as p, withCtx as c, createElementVNode as i } from "vue";
import { RevIcon as l } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconMoreVertical",
  __name: "IconMoreVertical",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (s, e) => (n(), a(m(l), p(o, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        i("path", { d: "M14 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
